const a = {
  code: "pt",
  facebook: "pt_PT",
  label: "Português",
  loadingText: "Carregandot...",
  translations: {
    ar: "Árabe",
    de: "Alemão",
    en: "Inglês",
    es: "Espanhol",
    fr: "Francês",
    he: "Hebraico",
    hi: "Hindi",
    id: "Indonésia",
    it: "Italiano",
    ja: "Japonês",
    km: "Khmer",
    ko: "Coreano",
    lo: "Lao",
    ms: "Malaio",
    nl: "Holandês",
    pt: "Português",
    ru: "Russo",
    th: "Tailandês",
    tl: "Filipina",
    tr: "Turco",
    vi: "Vietnamita",
    "zh-CN": "Chinês (Simp.)",
    "zh-TW": "Chinês (Trad.)"
  }
};
export {
  a as portuguese
};
